import { useMemo } from 'react';
import { KeyedMutator } from 'swr';

import { ProposalProps } from '~/data/proposals';
import {
  GetProposalsProps,
  useGetProposals,
} from '~/data/proposals/useGetProposals';
import { ProposalTrackingListResultDto } from '~/services/Http/client.iam.generated';

type PropsType = {
  details: GetProposalsProps;
  positions: GetProposalsProps;
};

type GetSWRProps<T> = {
  isLoading: boolean;
  mutate: KeyedMutator<T>;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  error: any;
};

export type ProposalTypeProposalsOutput = {
  proposals: ProposalProps[];
} & GetSWRProps<ProposalTrackingListResultDto>;

export type UseEmployeeProposalsDataOutput = {
  isLoading: boolean;
  details: ProposalTypeProposalsOutput;
  positions: ProposalTypeProposalsOutput;
};

export const useEmploymentProposalsData = (
  props: PropsType,
): UseEmployeeProposalsDataOutput => {
  const {
    data: { proposals: detailsProposals },
    ...detailsRest
  } = useGetProposals(props.details);

  const {
    data: { proposals: positionsProposals },
    ...positionsRest
  } = useGetProposals(props.positions);

  const { isLoading } = useMemo(() => {
    const isLoading = detailsRest.isLoading || positionsRest.isLoading;

    return {
      isLoading,
    };
  }, [detailsRest, positionsRest]);

  return {
    details: {
      proposals: detailsProposals,
      ...detailsRest,
    },
    positions: {
      proposals: positionsProposals,
      ...positionsRest,
    },
    isLoading,
  };
};
